import styled from "styled-components";

export const Heading1 = styled.h1`
font-family: RoadRadio;
font-size: 3.9rem;
font-style: normal;
font-weight: 900;
line-height: 3.9rem;
letter-spacing: 0px;
text-align: left;
`;
export const Heading2 = styled.h2`
font-family: RoadRadio;
font-size: 1.7rem;
font-style: normal;
font-weight: 400;
line-height: 1.9rem;
letter-spacing: 0px;
text-align: left;
`;
export const Heading3 = styled.h3`
font-family: RoadRadio;
font-size: 17px;
font-style: normal;
font-weight: 700;
line-height: 0px;
letter-spacing: 0px;
text-align: left;
`;
export const Heading4 = styled.h3`
font-family: RoadRadio;
font-size: 15px;
font-style: normal;
font-weight: 700;
line-height: 20px;
letter-spacing: 0px;
text-align: left;
`;
export const TextLogo = styled.h3`
color: white;
font-family: RoadRadio;
font-size: 24px;
font-style: normal;
font-weight: 900;
line-height: 18px;
letter-spacing: 0px;
text-align: center;
`;

export const TextButton1 = styled.div`
font-family: RoadRadio;
font-size: 17px;
font-style: normal;
font-weight: 700;
line-height: 22px;
letter-spacing: 0px;
text-align: left;
`;
export const TextButton2 = styled.div`
font-family: RoadRadio;
font-size: 13px;
font-style: normal;
font-weight: 700;
line-height: 18px;
letter-spacing: 0px;
text-align: left;
`;
export const TextCaption1 = styled.div`
font-family: RoadRadio;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 16px;
letter-spacing: 0px;
text-align: left;
`;
export const TextCaption2 = styled.div`
font-family: RoadRadio;
font-size: 11px;
font-style: normal;
font-weight: 700;
line-height: 13px;
letter-spacing: 0px;
text-align: left;
`;

export const Body1 = styled.div`
font-family: RoadRadio;
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: 20px;
letter-spacing: 0px;
text-align: left;
`;
export const Body2 = styled.div`
font-family: RoadRadio;
font-size: 13px;
font-style: normal;
font-weight: 400;
line-height: 18px;
letter-spacing: 0px;
text-align: left;
`;
export const SmallText = styled.div`
font-family: RoadRadio;
font-size: 11px;
font-style: normal;
font-weight: 400;
line-height: 13px;
letter-spacing: 0px;
text-align: left;
`;
